import { cn } from "@/lib/cn";

// Tecla — mostrar atajos en UI.
export function Kbd({ keys, className }: { keys: string; className?: string }) {
  return (
    <kbd
      className={cn(
        "inline-flex items-center justify-center min-w-[20px] h-5 px-1.5",
        "font-mono text-[10px] uppercase tracking-tight",
        "bg-surface-2 border border-border text-text-secondary",
        className,
      )}
    >
      {keys}
    </kbd>
  );
}
